import * as React from "react";
import DirectorySidebar from "./DirectorySidebar";
import { Directory } from "../../../../models/admin/Directory";
import { createBrowserHistory } from "history";
import {
  CreateDirectory,
  GetDirectoryList,
  LoadDirectory,
  UpdateSectionOne,
  UpdateSectionTwo,
  DeleteDirectory
} from "../../../../actions/DirectoriesActions";
import { GetBPList } from "../../../../actions/BPActions";
import { GetTemplateList } from "../../../../actions/TemplateActions";
import { LoadIntakeStrategies } from "../../../../actions/ISActions";
import DirectoryStore from "../../../../stores/DirectoryStore";
import BPStore from "../../../../stores/BPStore";
import ISStore from "../../../../stores/IntakeStrategyStore";
import TemplateStore from "../../../../stores/TemplateStore";
const customHistory = createBrowserHistory();
class DirectoryView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentDirectory: void 0,
      directoryId: 0,
      uploadPath: "",
      isActive: false,
      isSecOneDirty: false,
      isSecOneSaving: false,
      errorOne: "",
      isSecTwoDirty: false,
      isSecTwoSaving: false,
      errorTwo: "",
      routingType: 0,
      defaultFtp: 0,
      defaultTemplate: 0,
      legacyBPs: [],
      ftps: [],
      intakeStrats: [],
      selectedIs: "",
      isNewDirectory: false,
      deleteStatus: 0,
      allTemplates: [],
      filteredTemplates: []
    };
    this.updateDirectory = this.updateDirectory.bind(this);
    this.onStoreUpdate = this.onStoreUpdate.bind(this);
    this.isActiveChange = this.isActiveChange.bind(this);
    this.handleUploadPathChange = this.handleUploadPathChange.bind(this);
    this.handleSaveOneClick = this.handleSaveOneClick.bind(this);
    this.handleChangeRouting = this.handleChangeRouting.bind(this);
    this.onLegacyBPUpdate = this.onLegacyBPUpdate.bind(this);
    this.handleDefaultFtpChange = this.handleDefaultFtpChange.bind(this);
    this.handleSaveTwoClick = this.handleSaveTwoClick.bind(this);
    this.ftpChange = this.ftpChange.bind(this);
    this.onISUpdate = this.onISUpdate.bind(this);
    this.handleIsChange = this.handleIsChange.bind(this);
    this.startDelete = this.startDelete.bind(this);
    this.deleteDirectory = this.deleteDirectory.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.onTemplateUpdate = this.onTemplateUpdate.bind(this);
    this.updateFileteredTemplates = this.updateFileteredTemplates.bind(this);
    this.onTemplateSelect = this.onTemplateSelect.bind(this);
  }
  componentDidMount() {
    DirectoryStore.addChangeListener(this.onStoreUpdate);
    BPStore.addChangeListener(this.onLegacyBPUpdate);
    ISStore.addChangeListener(this.onISUpdate);
    TemplateStore.addChangeListener(this.onTemplateUpdate);
    this.updateDirectory();
    GetBPList();
    GetTemplateList();
    LoadIntakeStrategies();
  }
  componentWillUnmount() {
    DirectoryStore.removeChangeListener(this.onStoreUpdate);
    BPStore.removeChangeListener(this.onLegacyBPUpdate);
    ISStore.removeChangeListener(this.onISUpdate);
    TemplateStore.removeChangeListener(this.onTemplateUpdate);
  }
  componentDidUpdate() {
    this.updateDirectory();
  }
  updateDirectory() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let dirId = parseInt(pathParts[pathParts.length - 1], 10);
    if (this.state.directoryId !== dirId) {
      this.setState({ directoryId: dirId });
      LoadDirectory(dirId);
    }
    if (this.state.currentDirectory === void 0) {
      if (dirId !== 0) {
        LoadDirectory(dirId);
      }
      if (dirId === 0) {
        let currentDir = new Directory();
        currentDir.uploadPath = "New Directory";
        currentDir.uploadId = 0;
        this.setState({
          currentDirectory: currentDir,
          isNewDirectory: true,
          isActive: true,
          uploadPath: ""
        });
      }
    }
  }
  isActiveChange(e) {
    this.setState({ isActive: e.target.checked, isSecOneDirty: true });
  }
  onStoreUpdate() {
    let lastAction = DirectoryStore.lastChange();
    if (lastAction === "DirectoriesLoadOne") {
      let dir = DirectoryStore.getCurrentDirectory();
      this.setState({
        currentDirectory: dir,
        uploadPath: dir.uploadPath,
        isActive: dir.isActive,
        isSecOneDirty: false,
        isSecOneSaving: false,
        routingType: dir.intakeRoutingType,
        defaultFtp: dir.defaultBPId,
        ftps: dir.bPs,
        selectedIs: dir.intakeStrategyId,
        isSecTwoDirty: false,
        isSecTwoSaving: false,
        isNewDirectory: false
      });
    }
    if (lastAction === "DirectoriesUpdateOne") {
      let lastError = DirectoryStore.getLastError();
      if (lastError === "") {
        let newDir = DirectoryStore.getCurrentDirectory();
        if (newDir.uploadId !== this.state.currentDirectory.uploadId) {
          customHistory.push(`/Admin/DirectoryView/${newDir.uploadId}`);
        }
        this.setState({
          errorOne: "",
          currentDirectory: newDir,
          uploadPath: newDir.uploadPath,
          isActive: newDir.isActive,
          ftps: newDir.bPs,
          routingType: newDir.intakeRoutingType,
          selectedIs: newDir.intakeStrategyId,
          isSecOneSaving: false,
          isSecTwoDirty: false,
          isSecOneDirty: false,
          isSecTwoSaving: false
        });
        GetDirectoryList();
      } else {
        this.setState({ isSecOneSaving: false, errorOne: lastError });
      }
    }
    if (lastAction === "DirectoriesDelete") {
      let lastError = DirectoryStore.getLastError();
      if (lastError === "") {
        customHistory.push("Admin/Directories");
      } else {
        this.setState({ isSecOneSaving: false, errorOne: lastError });
      }
    }
  }
  onTemplateUpdate() {
    let templates = TemplateStore.getTemplateList();
    this.setState({ allTemplates: templates }, this.updateFileteredTemplates);
  }
  onLegacyBPUpdate() {
    let bps = BPStore.getBPList();
    this.setState({ legacyBPs: bps });
  }
  onISUpdate() {
    let intakes = ISStore.getIntakeStrategies();
    this.setState({ intakeStrats: intakes });
  }
  handleUploadPathChange(e) {
    this.setState({ uploadPath: e.target.value, isSecOneDirty: true });
  }
  handleSaveOneClick(e) {
    this.setState({ isSecOneSaving: true });
    if (this.state.isNewDirectory) {
      CreateDirectory(this.state.uploadPath, this.state.isActive);
    } else {
      UpdateSectionOne(
        this.state.currentDirectory.uploadId,
        this.state.uploadPath,
        this.state.isActive
      );
    }
  }
  handleSaveTwoClick(e) {
    this.setState({ isSecTwoSaving: true });
    UpdateSectionTwo(
      this.state.currentDirectory.uploadId,
      this.state.routingType,
      this.state.ftps,
      this.state.defaultFtp,
      this.state.defaultTemplate,
      this.state.selectedIs
    );
  }
  handleChangeRouting(e) {
    this.setState({
      isSecTwoDirty: true,
      routingType: parseInt(e.target.value, 10)
    });
  }
  handleIsChange(e) {
    this.setState({
      isSecTwoDirty: true,
      selectedIs: e.target.value
    });
  }
  ftpChange(e) {
    let ftps = this.state.ftps;
    let targetBp = parseInt(e.target.value, 10);
    if (e.target.checked && ftps.indexOf(targetBp) === -1) {
      ftps.push(targetBp);
    }
    if (!e.target.checked && ftps.indexOf(targetBp) !== -1) {
      let idx = ftps.indexOf(targetBp);
      ftps.splice(idx, 1);
    }
    this.setState({ isSecTwoDirty: true, ftps });
  }
  handleDefaultFtpChange(e) {
    this.setState({
      isSecTwoDirty: true,
      defaultFtp: parseInt(e.target.value, 10)
    }, this.updateFileteredTemplates);
  }
  updateFileteredTemplates() {
    let bp = this.state.legacyBPs.find((f) => f.bpId === this.state.defaultFtp);
    if (bp !== void 0) {
      let tempGroup = this.state.allTemplates.find((f) => f.formTypeId === bp.formTypeId);
      if (tempGroup !== void 0) {
        this.setState({ filteredTemplates: tempGroup.templates });
      } else {
        this.setState({ filteredTemplates: [] });
      }
    }
  }
  startDelete() {
    this.setState({ deleteStatus: 1 });
  }
  deleteDirectory() {
    DeleteDirectory(this.state.currentDirectory.uploadId);
    this.setState({ deleteStatus: 0 });
  }
  cancelDelete() {
    this.setState({ deleteStatus: 0 });
  }
  onTemplateSelect(e) {
    console.log(e.target.value);
    this.setState({ defaultTemplate: parseInt(e.target.value, 10) });
    this.setState({ isSecTwoDirty: true });
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container-fluid", style: { height: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "row flex-nowrap", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(DirectorySidebar, null), this.state.currentDirectory !== void 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "flex-fill",
        style: { backgroundColor: "#efefef", overflow: "scroll" }
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            marginTop: "20px",
            marginLeft: "30px",
            marginRight: "30px",
            maxHeight: "620px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("h4", null, /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-folder" }), "  ", this.state.currentDirectory.uploadPath)),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "uploadPathTxt", className: "form-label" }, "Upload Path:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "uploadPathTxt",
            value: this.state.uploadPath,
            onChange: this.handleUploadPathChange
          }
        )), /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "form-check form-switch",
            style: { marginTop: "10px" }
          },
          /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "form-check-input",
              type: "checkbox",
              id: "flexSwitchCheckChecked",
              onChange: this.isActiveChange,
              checked: this.state.isActive
            }
          ),
          /* @__PURE__ */ React.createElement(
            "label",
            {
              className: "form-check-label",
              htmlFor: "flexSwitchCheckChecked"
            },
            this.state.isActive && /* @__PURE__ */ React.createElement("span", null, "Active"),
            !this.state.isActive && /* @__PURE__ */ React.createElement("span", null, "Inactive")
          )
        ), /* @__PURE__ */ React.createElement("div", { className: "mb-3", style: { marginTop: "8px" } }, this.state.isSecOneDirty && !this.state.isSecOneSaving && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary",
            onClick: this.handleSaveOneClick
          },
          "Save"
        ), !this.state.isSecOneDirty && !this.state.isSecOneSaving && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "btn btn-primary disabled" }, "Save"), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-danger",
            style: { marginLeft: "6px" },
            onClick: this.startDelete
          },
          "Delete"
        )), this.state.isSecOneSaving && /* @__PURE__ */ React.createElement("i", { className: "fas fa-spinner fa-spin fa-2x" }), this.state.deleteStatus === 1 && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "alert alert-danger",
            style: { marginTop: "6px" },
            role: "alert"
          },
          /* @__PURE__ */ React.createElement("p", null, "Are you sure you want to delete this directory?"),
          /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-danger",
              onClick: this.deleteDirectory
            },
            "Yes - Delete"
          ),
          /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-secondary",
              style: { marginLeft: "6px" },
              onClick: this.cancelDelete
            },
            "Cancel"
          )
        ), this.state.errorOne !== "" && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "alert alert-danger",
            style: { marginTop: "6px" },
            role: "alert"
          },
          this.state.errorOne
        )))
      ),
      !this.state.isNewDirectory && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            marginTop: "20px",
            marginLeft: "30px",
            marginRight: "30px",
            maxHeight: "620px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("h4", null, "Intake Routing")),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col" }, /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "radio",
            name: "stdRoutingRadio",
            id: "stdRoutingRdo",
            value: "1",
            checked: this.state.routingType === 1,
            onChange: this.handleChangeRouting
          }
        ), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "stdRoutingRdo"
          },
          "Legacy Routing"
        ))), /* @__PURE__ */ React.createElement("div", { className: "col" }, /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "form-check-input",
            type: "radio",
            name: "intakeStrategyRadio",
            id: "intakeStrategyRdo",
            value: "2",
            checked: this.state.routingType === 2,
            onChange: this.handleChangeRouting
          }
        ), /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "intakeStrategyRdo"
          },
          "Intake Strategy"
        )))), this.state.routingType === 1 && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { style: { marginTop: "10px" } }, "Try these business processes:"), /* @__PURE__ */ React.createElement("div", { style: { maxHeight: "280px", overflowY: "auto" } }, this.state.legacyBPs.map((bp) => /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "form-check form-switch",
            style: { marginTop: "5px" },
            key: bp.bpId
          },
          /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "form-check-input",
              type: "checkbox",
              value: bp.bpId,
              onChange: this.ftpChange,
              checked: this.state.ftps.indexOf(bp.bpId) !== -1
            }
          ),
          /* @__PURE__ */ React.createElement(
            "label",
            {
              className: "form-check-label",
              htmlFor: "flexSwitchCheckChecked"
            },
            bp.bpName
          )
        ))), /* @__PURE__ */ React.createElement("div", { style: { marginTop: "10px" } }, "If none match, use this:"), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            "aria-label": "Select default business process",
            value: this.state.defaultFtp,
            onChange: this.handleDefaultFtpChange
          },
          /* @__PURE__ */ React.createElement("option", { value: "0" }, "Select a Business Process"),
          this.state.legacyBPs.map((bp) => /* @__PURE__ */ React.createElement("option", { key: bp.bpId, value: bp.bpId }, bp.bpName))
        )), /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            "aria-label": "Select default template",
            value: this.state.defaultTemplate,
            onChange: (e) => this.onTemplateSelect(e)
          },
          /* @__PURE__ */ React.createElement("option", { value: "0" }, "Select default Template"),
          this.state.filteredTemplates.map((temp) => /* @__PURE__ */ React.createElement("option", { key: temp.templateId, value: temp.templateId }, temp.name))
        )))), this.state.routingType === 2 && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "h5", style: { marginTop: "10px" } }, "Select an Intake Strategy:"), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            value: this.state.selectedIs,
            onChange: this.handleIsChange
          },
          /* @__PURE__ */ React.createElement("option", { value: "0" }, "Select an intake strategy"),
          this.state.intakeStrats.map((intake) => /* @__PURE__ */ React.createElement("option", { key: intake.id, value: intake.objectId }, intake.isName))
        )), /* @__PURE__ */ React.createElement("div", { className: "mb-3", style: { marginTop: "8px" } }, this.state.isSecTwoDirty && !this.state.isSecTwoSaving && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary",
            onClick: this.handleSaveTwoClick
          },
          "Save"
        ), !this.state.isSecTwoDirty && !this.state.isSecTwoSaving && /* @__PURE__ */ React.createElement("button", { className: "btn btn-primary disabled" }, "Save"), this.state.isSecTwoSaving && /* @__PURE__ */ React.createElement("i", { className: "fas fa-spinner fa-spin fa-2x" })))
      )
    )));
  }
}
export default DirectoryView;
